/**
 * System section: health + device diagnostics under SubMenu tabs.
 * Admin-only (the menu hides it for other roles; the diagnostics API is
 * admin-restricted anyway).
 */

import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import {
  MonitorHeartOutlined as HealthIcon,
  DevicesOutlined as DevicesIcon,
  CallSplitOutlined as RoutingIcon,
} from '@mui/icons-material';
import { SubMenu } from '@/components/common';
import { HealthView } from './HealthView';
import { DevicesView } from './DevicesView';
import { RoutingHealthView } from './RoutingHealthView';

export const SystemPage = () => {
  const translate = useTranslate();
  const [activeView, setActiveView] = useState('health');

  const tabs = [
    { value: 'health', label: translate('pages.system.tabs.health'), icon: <HealthIcon /> },
    { value: 'devices', label: translate('pages.system.tabs.devices'), icon: <DevicesIcon /> },
    { value: 'routing', label: translate('pages.system.tabs.routing'), icon: <RoutingIcon /> },
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <SubMenu items={tabs} activeItem={activeView} onChange={setActiveView} />
      <Box sx={{ mt: 2 }}>
        {activeView === 'health' && <HealthView />}
        {activeView === 'devices' && <DevicesView />}
        {activeView === 'routing' && <RoutingHealthView />}
      </Box>
    </Box>
  );
};

export default SystemPage;
